/* Add sortable to all columns Apr 14, 2022 */
/* Add CustomFields Sep 23, 2023 */
/* Add email,phoneno,url types to Custom Fields Nov 18, 2023 */
/* Add officePhoneno, mobilePhoneNo, otherPhoneNo Aug 24, 2024 */
/* Amend for Performance Dec 7, 2024 */
/* Add multiSelect to CustomData Fields Dec 21, 2024 */
/* Add reportWidth, notes  Apr 30, 2026 */
<template lang="pug">
	div(class="acct-nav")
		div(class="nav-header")
			div
				b-button(v-for="t in d_tabs" :key="t.ix" variant="none" :pressed="d_tabCurr.ix==t.ix" @click="m_tabClick(t)") {{t.lbl}}
			slot(v-if="d_tabCurr.ix!=1" name="team-member-filter" :fTM="true")
		div
			b-card
				b-card-body
					kt-table(
						p_appEntKey="acct" 
						:ref="'kt-table' + c_tblIdKey"
						:p_tblIdKey="c_tblIdKey"
						:p_opts="c_ktOptions"
						:p_cols="c_ktColumns"
						:p_qryPrms="c_qryPrms"
						:p_tbNote="c_tbNote"
						:p_tbInfo="c_tbInfo"
					)
</template>

<script>
import KTTable from "@/components/Ctrl/KT-Table.vue";
import {userInfo,refData} from "@/utils/ref-data.js";
import util from "@/utils/util.js";
export default {
	name: "acct-nav",
	components: {
		"kt-table": KTTable,
	},
	created() {
		//Kepp Order
		this.d_tabs = fn_getTabs(this);
		//this.d_tabCurr = this.$parent.d_cuFilter ? this.d_tabs[1] : this.d_tabs[0];

		var d_qryPrms;
		if(window.localStorage.getItem(window.location.href+'-quickFilter')) {
			
			try{
				d_qryPrms=JSON.parse(window.localStorage.getItem(window.location.href+'-quickFilter'));
				} catch(err){d_qryPrms=null;}
		
		
		if(d_qryPrms) {
		
			this.d_tabs[d_qryPrms.ix].qryPrms=d_qryPrms;
			this.d_tabCurr = this.d_tabs[d_qryPrms.ix];
		
		} 
		
		} else this.d_tabCurr = this.$parent.d_cuFilter ? this.d_tabs[1] : this.d_tabs[0];
	},
	data() {
		return {
			d_tabs: [],
			d_tabCurr: {},
			d_teamMemberId: userInfo.getUserInfo().teamMember.teamMemberId,
			d_withArchived:false,
		};
	},
	computed: {
		c_ktOptions() {return {detailView: true};},
		c_ktColumns() {return fn_getColumns();},
		c_tblIdKey(){return this.d_tabCurr.tblIdKey;},
		c_qryPrms(){return this.d_tabCurr.qryPrms;},
		c_tbNote(){return this.d_tabCurr.tbNote;},
		c_tbInfo(){return this.d_tabCurr.fn_tbInfo();},
		c_skipLoad(){return this.d_tabCurr.skipLoad;},
	},
	methods: {
		m_tabClick(t){
			t.withArchived=false;
			t.filterBtns||[].filter(b=>b.osNm == 'Archived').forEach(x =>{ x.state = false;});
			this.d_tabCurr=t;
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(this.d_tabCurr.qryPrms));
				}	
	},
	watch: {
		d_tabCurr(nv, ov) {
			if (nv.ix == 1) this.$parent.d_cuFilter = true;
			else if (ov.ix == 1 || nv == 0) this.$parent.d_cuFilter = null;

			if (ov.ix >= 0) fn_setTabProps(nv, this);
			window.localStorage.setItem(window.location.href+'-quickFilter',JSON.stringify(this.d_tabCurr.qryPrms));
			
		},
		'$parent.c_cutmKey'(nv, ov) {
			let ct = this.d_tabCurr;
			if (ct.ix == 0 && ov != -1) fn_setTabProps(ct, this);
		},
	}
};
export {fn_getColumns};
function fn_getColumns() {
	var columns = [
		{
			field: "accountNo",
			_numKey: true,
			openOnClick: true,
			default: true,
			sortable:true
		},
		{
			field: "accountName",
			openOnClick: true,
			default: true,
			sortable:true,
			reportWidth:500
		},
		{
			field: "accountTypeId",
			_refData: refData.accountTypes,
			default: true,
			sortable:true
		},
		{
			field: "ownerTypeId",
			_refData: refData.ownerTypes,
			default: true,
			sortable:true
		},
		{
			field: "accountOwnerId",
			_refId: "teamMemberId",
			default: true,
			sortable:true
		},
		{field: "email",
		datatype:"email",
		fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
		sortable:true},
		{field: "phoneNo",
		datatype:"tel",
		fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
		valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
		sortable:true},
		{field: "website",
		datatype:"url",
		fn_hrefLink: (type,value)=> {return value.includes('http')?util.fn_hrefLink(type, value):util.fn_hrefLink(type, 'http://'+value);},
		sortable:true},
		{field: "streetAddress",sortable:true, reportWidth:500},
		{
			field: "city",
			default: true,
			sortable:true
		},
		{
			field: "stateProvince",
			title: "State or Province",
			sortable:true
		},
		{field: "zipCode",
		sortable:true},
		{field: "inactive"},

		{field: "createdById", _refId: "teamMemberId"},
		{field: "createdUTC"},
		{field: "updatedById", _refId: "teamMemberId"},
		{field: "updatedUTC"},
		{field:"officePhoneNo",
		title:"Office#",
		datatype:"tel",
		sortable:true,
		fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
		valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;}
		},
		{field:"mobilePhoneNo",
		title:"Mobile#",
		datatype:"tel",
		sortable:true,
		fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
		valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;}
		},
		{field:"otherPhoneNo",
		title:"Other#",
		datatype:"tel",
		sortable:true,
		fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
		valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;}
		},
		{field:"externalContacts", title:"Account Contacts"},
		{field:"assignedTeamMembers", 
		title:"Assigned Team Members",
		valFmtFn: val => {return val?val.map(v=>{return v.teamMemberName;}).join():null;}
		},
		{field:"notes", title:"Notes",htmlFn:val => {return val;}, 
		valFmtFn: val =>{return val?val.replaceAll('<p>','').replaceAll('</p>',''):null;},
		datatype:'multi-line',
		reportWidth:500},
	];
	var allColumns=[...columns, ...fn_addCustomFields()];
	return allColumns;
}

function fn_getTabs(vc) {
	let tbInfoHelper = (who) => `Accounts on which ${who} the Account Owner or an Assigned Team Member`;
	let tabs = [
		{
			ix: 0,
			lbl: 'All',
			tblIdKey: '',
			fn_qryPrms: () => {
				let tmf = vc.$parent.d_tmFilter;
				return {
					ix:0,
					teamMemberId: tmf ? tmf.teamMemberId : null,
					d_withArchived:false,
				};
			},
			fn_tbInfo: () => !vc.$parent.d_tmFilter ? null : tbInfoHelper('the selected Team Member is'),
		},
		{
			ix: 1,
			lbl: 'My Accounts',
			tblIdKey: '-currentUser',
			fn_qryPrms: () => {
				return {
					ix:1,
					teamMemberId:vc.d_teamMemberId,
					currentUser: true,
					d_withArchived:false,
				};
			},
			fn_tbInfo: () => tbInfoHelper('you are'),
		},

	];
	tabs.forEach(x => {
		fn_setTabProps(x, vc);
	});
	return tabs;
}

function fn_note(vc) {
	let tmfLbl = vc.$parent.c_tmFilterLbl;
	let note = tmfLbl || 'Accounts';
	return (tmfLbl ? '' : 'All ') + note;
}

function fn_setTabProps(tab, vc) {
	tab.qryPrms = tab.fn_qryPrms();
	tab.tbNote = fn_note(vc);
}
function fn_addCustomFields(){
	var customFields=refData.customFields.filter(c=>(c.context=='acct'));
	var customColumns=[];
	var customColumn;
	customFields.forEach(cf=>{
				customColumn={
					field: cf.name,
						title: cf.label,
						sortable:false,
						visible:true,
						datatype:cf.type,
						__dbvw: true,
						valFmtFn: cf.type=='money'?val => val?'$'+Number(val).toLocaleString():null:null,
						fn_hrefLink: ['email','tel','url'].includes(cf.type)?(type,value)=> 
						{if(type=='url'&&!value.includes('http')) value='http://'+value;
						return util.fn_hrefLink(type, value);}:null,
						fn_hrefAppLink: ['oppr','proj','acct','extr','cmpt','team'].includes(cf.type)?(type,value)=> {return util.fn_hrefVwRec(type, value);}:null,
						multiSelect:cf.multiSelect,
						listOfValues:cf.listOfValues,
						customField:true,
						};			
	if(customColumn.multiSelect) customColumn.valFmtFn=(val)=>{return val instanceof Array?val.join():null;};		
	customColumns.push(customColumn);

		});
	return customColumns;
}
</script>

<style lang="less">
</style>